import { render, staticRenderFns } from "./AgentCreateForm.vue?vue&type=template&id=5c40fdf3&"
import script from "./agent-create-form.ts?vue&type=script&lang=ts&"
export * from "./agent-create-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports